module.exports = __webpack_public_path__ + "static/media/sweetmayo.260c5714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/sweetmayo.jpg
// module id = 151
// module chunks = 0